import React from 'react';
import clsx from 'clsx';
import styles from './Select.module.scss';

type Props = {
  variant?: 'full' | 'middle';
  disabled?: boolean;
  className?: string;
  onChange?: any;
  children: React.ReactNode;
};

const Select = React.forwardRef<HTMLSelectElement, Props>((props, ref): JSX.Element => {
  const {
    variant,
    children,
    disabled = false,
    className,
    onChange,
    ...other
  } = props;

  return (
    <select
      ref={ref}
      className={clsx(styles.root, variant && styles[variant], className)}
      disabled={disabled}
      {...other}
      onChange={onChange}
    >
      {children}
    </select>
  );
});

export default React.memo(Select);